import { gql } from '@apollo/client';

export const GQL_BANK_ACCOUNT_CREATE = gql`
  mutation insertBankAccount($input: BankAccountInput) {
    insertBankAccount(input: $input) {
      id
      accountName
      accountNumber
      bank
    }
  }
`;
export const GQL_BANK_ACCOUNT_UPDATE_PROXY = gql`
  mutation editBankAccountProxy($input: BankAccountInput) {
    editBankAccountProxy(input: $input) {
      id
      accountName
      accountNumber
      bank
      errorMessage
    }
  }
`;
